module.exports = __webpack_public_path__ + "static/media/root_logo.b0d5c643.png";